import { Expose } from 'class-transformer';

export class CenterModel {
  constructor(text: string = '', value: number = 0) {
    this.text = text;
    this.value = value;
  }

  @Expose({ name: 'centerName' })
  text: string;

  @Expose({ name: 'saleOrgMasterCenterId' })
  value: number;
}
